// Generated by scripts/update-seeq-icons.js from src/svg/seeq/long-dash-dot-dot.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcLongDashDotDot = {
  prefix: 'fak',
  iconName: 'long-dash-dot-dot' as IconName,
  icon: [
    1024,
    1024,
    [],
    'f910',
    'M721.9 465.9h302.1v46.1h-302.1v-46.1zM25.6 512h97.3v46.1h-97.3v-46.1zM721.9 512h302.1v46.1h-302.1v-46.1zM25.6 465.9h97.3v46.1h-97.3v-46.1zM373.8 512h97.2v46.1h-97.2v-46.1zM373.8 465.9h97.2v46.1h-97.2v-46.1z',
  ],
} satisfies IconDefinition;
